import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

import SubSection from '../common/SubSection.vue';
import { computed } from "vue";
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'RiskWarnings',
  setup(__props) {

const store = useStore();

const showTermsOfUse = computed<boolean>(() => store.state.configuration.showTermsOfUse);
const showBespokeRiskWarnings = computed<boolean>(() => store.state.configuration.finishBespokeRiskWarnings);
const bespokeRiskWarnings = computed<string>(() => store.state.configuration.finishBespokeRiskWarnings);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SubSection, {
        title: "Risk warnings",
        showHelp: false
      }, {
        default: _withCtx(() => [
          (showBespokeRiskWarnings.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: bespokeRiskWarnings.value
              }, null, 8, _hoisted_3))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _cache[1] || (_cache[1] = _createElementVNode("p", null, [
                  _createElementVNode("strong", null, " Pensions are an investment, so the value of them is not guaranteed, they may fall as well as rise. You may get back less than you invest. Tax rules can also change in the future. ")
                ], -1)),
                (showTermsOfUse.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, _cache[0] || (_cache[0] = [
                      _createTextVNode(" Thank you for using our tool. Please note that in doing so you are agreeing to our full "),
                      _createElementVNode("a", {
                        href: "/Home/TermsandConditions",
                        target: "_blank"
                      }, "terms and conditions", -1),
                      _createTextVNode(". ")
                    ])))
                  : (_openBlock(), _createElementBlock("p", _hoisted_5, "Thank you for using our tool.")),
                _cache[2] || (_cache[2] = _createElementVNode("p", null, " The tool is intended as a guidance and calculation tool only and does not provide financial advice in any form. In addition, we make no recommendation of suitable investments for your particular circumstances. ", -1)),
                _cache[3] || (_cache[3] = _createElementVNode("p", null, " The aim of our tool is to provide you with a plan which can help you understand how you may combine your pension pots with everything else you have to try to provide what you want in retirement. You can then use this plan and implement this yourself or use it with the help of a financial adviser. We recommend seeking financial advice before implementing any retirement plan rather than trying to do this on your own. You can find a financial adviser who is authorised and regulated by the Financial Conduct Authority (FCA) via our website if you wish to. ", -1)),
                _cache[4] || (_cache[4] = _createElementVNode("p", null, " The calculations provided will be dependent on the information entered and we accept no responsibility for the accuracy of this information. The calculations also rely on a number of assumptions which are detailed below. In reality, what actually happens will always differ from these assumptions as what your pension pots, savings and investments are worth in the future are dependent on a number of factors which are impossible to predict. ", -1))
              ], 64))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})